import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { CardContent, CircularProgress, Grid } from "@mui/material";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { resetPassword } from "../../../actions/password";
import Logo from "../../../assets/images/logo_medium.png";
import snackbarUtils from "../../../utils/snackbarUtils";
import FormikCaptcha from "../../commons/formik/formikCaptcha";
import FormikForm from "../../commons/formik/formikForm";
import FormikTextField from "../../commons/formik/formikTextField";
import { StyledForm } from "../../styled/form";
import { StyledPasswordRecoveryContainer } from "../../styled/password";
import LoginFooter from "../login/loginFooter";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Dirección de correo inválida")
    .required("Campo obligatorio"),
});

const initialValues = {
  email: "",
};

const PasswordRecoveryContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const captchaRef = useRef();
  const loading = useSelector(
    (state) => state.password.resetPassword.isFetching,
  );

  const handleSubmitEmail = (values) => {
    dispatch(resetPassword(values.email, values.token))
      .then((datos) => {
        snackbarUtils.success(
          "Le enviaremos un e-mail a la brevedad.\nRecuerde verificar el correo no deseado o spam.",
        );
        setTimeout(() => {
          navigate("/account/login");
        }, 4000);
      })
      .catch((error) => {
        captchaRef.current?.reset();
      });
  };

  return (
    <StyledPasswordRecoveryContainer.GridContainer
      container
      justifyContent="center">
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmitEmail}>
        {({ values }) => (
          <StyledPasswordRecoveryContainer.LoginCard>
            <StyledForm.Container>

              <CardContent>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  direction="column">
                  <StyledPasswordRecoveryContainer.LogoStyled
                    src={Logo}
                    alt=""
                  />
                </Grid>
                <StyledPasswordRecoveryContainer.Text>
                  Recuperar contraseña
                </StyledPasswordRecoveryContainer.Text>

                <Grid container direction={"row"} spacing={2} nowrap="true">
                  <StyledPasswordRecoveryContainer.GridItemAligned item xs={12}>
                    <EmailOutlinedIcon />
                    <FormikTextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Correo electrónico"
                      name="email"
                      autoFocus
                      type="text"
                    />
                  </StyledPasswordRecoveryContainer.GridItemAligned>
                </Grid>
                <Grid container justifyContent="center" item xs={12}>
                  <FormikCaptcha ref={captchaRef} />
                </Grid>

                <StyledPasswordRecoveryContainer.ButtonStyled
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                  disabled={loading || (CONFIG.useCaptcha && !values.token)}>
                  {loading ? (
                    <CircularProgress
                      size={24}
                      thickness={4}
                      color="secondary"
                    />
                  ) : (
                    "Enviar"
                  )}
                </StyledPasswordRecoveryContainer.ButtonStyled>
              </CardContent>
            </StyledForm.Container>
            <LoginFooter loginAccount />
          </StyledPasswordRecoveryContainer.LoginCard>
        )}
      </FormikForm>
    </StyledPasswordRecoveryContainer.GridContainer>
  );
};

export default PasswordRecoveryContainer;
